import '../assets/css/history.css';
import { TitleBar } from '../components/TitleBar'
import Count from '../components/Count';
import Map from '../components/Map';
import { TopButton } from "../components/TopButton"

import { useRef, useEffect } from 'react';
import { gsap } from "gsap";
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from "gsap/ScrollTrigger"


export default function HistoryPage() {

  useEffect(()=>{
    const titleElement = document.getElementsByTagName('title')[0];
    titleElement.innerHTML = `히스토리 | 어르신본죽왔어요`;
  },[]);

  gsap.registerPlugin(useGSAP, ScrollTrigger);
  const container = useRef();

  useGSAP(() => {
    let tl01 = gsap.timeline({
      default:{duration: 0.1},
    }); // 인트로
    
    tl01.from('.motiona1', { opacity: 0, y: 100, })
        .from('.motiona3', { opacity: 0, y: 100, })
        .from('.motionb1', { opacity: 0, y: 100, })
        .from('.motionb2', { opacity: 0, y: 100, })
        .from('.motionc1', { opacity: 0, y: 100, })
        .from('.motionc2', { opacity: 0, y: 100, })

  }, { scope: container });


    return (
      <article ref={container}>
        <TitleBar />
        <TopButton />

        <section id="count" className='section text-center'>
          <h3 className='motiona1'>'어르신 본죽 왔어요'의 따뜻한 결실입니다</h3>
          <div className='motiona3'>
            <Count />
          </div>
        </section>

        <section id='map' className='section'>
          <div className='inner text-center'>
            <h3 className='motionb1'>나눔지도</h3>
            <div className='motionb2'><Map /></div>
          </div>
        </section>

        <section id='history-table' className='section'>
          <div className='inner'>
            <h3 className='motionc1'>걸어온 길</h3>
            <div className='motionc2'>
              <table className='table'>
                <tbody>
                <tr>
                  <td>현재</td>
                  <td>
                    <p>'어르신 본죽 왔어요' 정기 나눔 진행중</p>
                    <p>동대문 쪽방촌 월간 섬김 본죽 나눔 진행중</p>
                    <p>혹서기/동지 절기 캠페인 본죽 나눔 진행중 </p>
                  </td>
                </tr>
                <tr>
                  <td>2022년</td>
                  <td>
                    <p>독거노인종합지원센터 협력</p>
                    <p>취약노인 보호사업 공적 보건복지부장관 표창</p>
                  </td>
                </tr>
                <tr>
                  <td>2015년</td>
                  <td>
                    <p>'어르신 본죽 왔어요' 정기 나눔 시작</p>
                    <p>혹서기/동지 절기 캠페인 본죽 나눔 시작 </p>
                  </td>
                </tr>
                <tr>
                  <td>2010년</td>
                  <td>
                    <p>동대문 쪽방촌 월간 섬김 본죽 나눔 시작</p>
                  </td>
                </tr>
                <tr>
                  <td>2009년</td>
                  <td>
                    <p>지역사회 복지기관 본죽 나눔</p>
                  </td>
                </tr>
                <tr>
                  <td>2002년</td>
                  <td>
                    <p>본죽 대학로 1호점 나눔 시작</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>



      </article>
    );
  };
  